import React, { useState, useEffect } from 'react';
import {
  Add,
  Remove
} from "@mui/icons-material";
import { Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  User
} from "@models";
import { 
  Character,
} from "@dndModels";

import DandDAPI from "@dndUtilities/system_api";
import { makeStyles } from "@utilities/theme_utilities";
import FlexBox from '@components/layout/FlexBox';

interface Props { 
  character: Character;
  in_encounter: boolean;
  adding: boolean;
  char_id: string;
  onChange: (adding: boolean) => void;
}

const api = DandDAPI.getInstance();

export default function CharacterParticipant({
  character,
  in_encounter,
  adding,
  char_id,
  onChange
}: Props) {
  const [last_char_id, setLastCharId] = useState("");
  const [owner, setOwner] = useState<User | null>(null);

  // eslint-disable-next-line
  useEffect(() => {
    setLastCharId(char_id);
  });
  
  useEffect(() => {
    if (last_char_id !== char_id) {
      setLastCharId(char_id);
      load();
    }
    // eslint-disable-next-line 
  }, [char_id]);

  const load = () => {
    if (api.user !== null && 
      character.owner_id === api.user._id) {
      setOwner(api.user);
    } else {
      setOwner(null);
      const filter: any = {};
      filter["_id*ObjectID"] = character.owner_id;
      api.getUsers(filter).then((res: any) => {
        const users = res as User[];
        if (users.length > 0) {
          setOwner(users[0]);
        } else {
          console.error("User Retrieval Error");
          debugger;
        }
      });
    }
  }
      
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        // margin: "4px",
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <div className='padded'>
      <FlexBox direction="row" className={cx(classes.root)} style={{ width: "100%" }}>
        <FlexBox xs_expand={0} className="padded">
          <Fab size="small" color="primary" style={{ marginLeft: "8px" }}
            disabled={ in_encounter }
            onClick={ () => {
              onChange(!adding);
            }}>
            { in_encounter || adding ? <Remove/> : <Add/> }
          </Fab>
        </FlexBox>
        <FlexBox direction="column" className="padded">
          <FlexBox>
            { character.use_name }
          </FlexBox>
          <FlexBox className='small_label gray'>
            { character.race_and_class_string }
          </FlexBox>
          <FlexBox className='small_label gray'>
            Owner: { owner === null ? "Loading" : owner.use_name }
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </div>
  );
}
